
export function subscribe()
{

  const newEditUserId = messageDiv().getAttribute("data-new-edit-user-id");
  const channelInfo = window.app.smsOptInChannelInfo;

  if (channelInfo != null) {                      // if we navigate to another one but the channel is already there, then
    if (channelInfo.newEditUserId == newEditUserId)     // we need to unsubscribe unless it's for this user id
      return channelInfo.subscription;
    else
      unsubscribe();
  }

  const subscription = window.app.consumer.subscriptions.create({
    channel: "SMSOptInChannel",
    new_edit_user_id: newEditUserId,
  },
  {
    received: update,
  })

  window.app.smsOptInChannelInfo = {
    subscription: subscription,
    newEditUserId: newEditUserId,
  }

  return subscription;

}

export function unsubscribe(){
  if (window.app.smsOptInChannelInfo != null){
    window.app.smsOptInChannelInfo.subscription.unsubscribe()
    window.app.smsOptInChannelInfo = null;
  }
}

function messageDiv(){
  return document.getElementById("opt-in-message-div");
}

function update(innerHTML) {
  messageDiv().innerHTML = innerHTML;
}
